import { render, staticRenderFns } from "./BeeConfirmDialog.vue?vue&type=template&id=4c8f56d8"
import script from "./BeeConfirmDialog.vue?vue&type=script&lang=js"
export * from "./BeeConfirmDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports